var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWasher({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 80,
    viewBox: "0 0 71 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V80H70.6177V0H0ZM65.9302 4.6875V18.7653H4.6875V4.6875H65.9302ZM4.6875 75.3125V23.4528H65.9302V75.3125H4.6875Z",
    fill: "#384336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38086 9.38232H15.6357V14.0698H9.38086V9.38232Z",
    fill: "#384336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3281 9.38232H26.583V14.0698H20.3281V9.38232Z",
    fill: "#384336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0352 9.38232H61.2361V14.0698H44.0352V9.38232Z",
    fill: "#384336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3087 28.1403C24.3877 28.1403 15.3667 36.4246 14.196 47.0386H9.37305V51.7261H14.196C15.3667 62.3407 24.3877 70.625 35.3087 70.625C47.022 70.625 56.5514 61.0956 56.5514 49.3823C56.5514 37.6697 47.022 28.1403 35.3087 28.1403ZM35.3087 65.9375C26.9756 65.9375 20.0621 59.7485 18.9202 51.7261H23.6748C24.7661 57.1515 29.5671 61.25 35.3087 61.25C41.8523 61.25 47.1764 55.9265 47.1764 49.3823C47.1764 42.8387 41.8523 37.5153 35.3087 37.5153C29.5671 37.5153 24.7661 41.6138 23.6748 47.0386H18.9202C20.0621 39.0161 26.9756 32.8278 35.3087 32.8278C44.4371 32.8278 51.8633 40.2539 51.8633 49.3823C51.8633 58.5107 44.4371 65.9375 35.3087 65.9375ZM28.1285 49.3823C28.1285 45.4236 31.3494 42.2028 35.3087 42.2028C39.2675 42.2028 42.4889 45.4236 42.4889 49.3823C42.4889 53.3417 39.2675 56.5625 35.3087 56.5625C31.3494 56.5625 28.1285 53.3417 28.1285 49.3823Z",
    fill: "#384336"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasher);
export default __webpack_public_path__ + "static/media/washer.9234456852466b6fa3a057849a948497.svg";
export { ForwardRef as ReactComponent };